import { render, staticRenderFns } from "./ButtonNine.vue?vue&type=template&id=9cfb7bb6&"
import script from "./ButtonNine.vue?vue&type=script&lang=ts&"
export * from "./ButtonNine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports